import { WorkspaceProfile } from "./SDKWorkspaceProfile";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class Workspace {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.id;
        this.profile = new WorkspaceProfile(model.profile);
        this.aiFeaturesEnabled = model.aiFeaturesEnabled;
        this.aiAskFeaturesEnabled = model.aiAskFeaturesEnabled;
        this.projectsEnabled = model.projectsEnabled;
        this.aiCustomInstruction = (_a = model.aiCustomInstruction) !== null && _a !== void 0 ? _a : null;
        this.defaultProjectRole = model.defaultProjectRole;
        this.defaultProjectAccessMode = model.defaultProjectAccessMode;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        return {
            id: this.id,
            profile: this.profile.toRemote(),
            aiFeaturesEnabled: this.aiFeaturesEnabled,
            aiAskFeaturesEnabled: this.aiAskFeaturesEnabled,
            projectsEnabled: this.projectsEnabled,
            aiCustomInstruction: this.aiCustomInstruction || undefined,
            defaultProjectRole: this.defaultProjectRole,
            defaultProjectAccessMode: this.defaultProjectAccessMode,
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        return {
            id: this.id,
            profile: this.profile.toTransport(),
            aiFeaturesEnabled: this.aiFeaturesEnabled,
            aiAskFeaturesEnabled: this.aiAskFeaturesEnabled,
            projectsEnabled: this.projectsEnabled,
            aiCustomInstruction: this.aiCustomInstruction || undefined,
            defaultProjectRole: this.defaultProjectRole,
            defaultProjectAccessMode: this.defaultProjectAccessMode,
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new Workspace(model);
    }
}
